import { useMemo, useState } from "react";

import { AdminSearch } from "../AdminSearch/AdminSearch";

import styles from "./relatedProductModal.module.css";

interface RelatedProductModalProps {
    isOpen: boolean;
    data: any[];
    onClose: () => void
}
export const RelatedProductModal = ({ isOpen, data, onClose }: RelatedProductModalProps) => {
    const [search, setSearch] = useState("");

    const filteredData = useMemo(() => {
        const searchTerm = search.trim().toLocaleLowerCase('de-DE');

        if (!searchTerm) {
            return data;
        }

        return data.filter((customer: any) =>
            customer.name?.toLocaleLowerCase('de-DE').includes(searchTerm)
        );
    }, [data, search]);

    if (!isOpen) return null;
    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div
                className={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
            >
                <p className={styles.modalTitle}>Zubehör</p>
                <button className={styles.closeButton} onClick={onClose}>
                    &times;
                </button>

                <div className={styles.modalBody}>
                    <AdminSearch searchTerm={search} handleInputChange={(e) => setSearch(e.target.value)} width='100%' height='40px' />
                    <div className={styles.modalList}>
                        <table className={styles.modalTable}>
                            <thead className={styles.modalListHeader}>
                                <tr>
                                    <th className={styles.tableNumber}>Nr.</th>
                                    <th>Name</th>
                                    <th>Einheit</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item) => (
                                    <tr key={item.id} className={styles.modalListItem}>
                                        <td>{item.referenceNumber}</td>
                                        <td>{item.name}</td>
                                        <td>{item.salesUnit?.name ?? ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    )
}